/* eslint-disable max-len */
function hexStringToByteArray(hexString : string) {
  if (hexString.length % 2 !== 0) throw new Error('Hex string has an odd length');
  const result = new Uint8Array(hexString.length / 2);
  for (let i = 0; i < hexString.length; i += 2) {
    result[i / 2] = parseInt(hexString.substring(i, i + 2), 16);
  }

  return result;
}

export async function encryptData(data: string, keyHex: string, ivHex: string): Promise<string> {
  const keyBuffer = hexStringToByteArray(keyHex);
  const iv = hexStringToByteArray(ivHex);
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);

  try {
    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      keyBuffer,
      { name: 'AES-CBC', length: 128 },
      false,
      ['encrypt'],
    );

    const encrypted = await window.crypto.subtle.encrypt(
      { name: 'AES-CBC', iv },
      cryptoKey,
      dataBuffer,
    );

    // Convert ArrayBuffer to Base64 without using the spread operator
    const encryptedBytes = new Uint8Array(encrypted);
    let binaryString = '';
    for (let i = 0; i < encryptedBytes.byteLength; i++) {
      binaryString += String.fromCharCode(encryptedBytes[i]);
    }
    console.log(`Encryted here binary before encode(i.e. before btoa): ${binaryString}`);

    return window.btoa(binaryString);
  } catch (error) {
    console.error('Encryption failed:', error);
    throw new Error('Failed to encrypt data.');
  }
}

export async function decryptData(encryptedBase64Data: string, keyHex : string, ivHex : string) {

  const keyBuffer = hexStringToByteArray(keyHex);
  const iv = hexStringToByteArray(ivHex);
  const encryptedDataBuffer = Uint8Array.from(atob(encryptedBase64Data), (c) => c.charCodeAt(0)).buffer;

  try {
    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      keyBuffer,
      { name: 'AES-CBC', length: 128 },
      false,
      ['decrypt'],
    );

    const decrypted = await window.crypto.subtle.decrypt(
      { name: 'AES-CBC', iv },
      cryptoKey,
      encryptedDataBuffer,
    );

    const dec = new TextDecoder();
    return JSON.parse(dec.decode(new Uint8Array(decrypted)));
  } catch (error) {
    console.error('Decryption failed:', error);
    throw new Error('Failed to decrypt data. Check key, IV, and encrypted data integrity.');
  }
}
